import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import Service from './edit.service'
import Form from './form.component'
import FormHelper from '../../../../../../utils/FormHelper'
import './edit.styles.scss'
import Dialog from '../../../../../../components/dialog/dialog.component'
import Loading from '../../../../../../components/loading/loading.component'

class Edit extends React.Component {

    constructor(props) {
        super(props)
        this.service = Service(this)
        this.state = this.service.getDefaultState()
    }

    componentDidMount() {
        this.service.loadSites()
    }

    onSubmit = (e) => {
        e.preventDefault()
        this.service.isValid() && this.service.save()
    }

    toggleShowPassword = () => this.setState({
        ...this.state,
        showPassword: !this.state.showPassword
    })

    render() {
        return (
            <div className="edit card">
                {(this.state.saving || this.state.loadingSites) && <Dialog><Loading /></Dialog>}
                <div className="header">
                    <h4>Edit Info</h4>
                </div>
                <div className={"flag " + this.state.flag.type}>
                    {this.state.flag.text}
                </div>
                <Form {...this.state} onChange={FormHelper(this, 'customer').onChange} showPassword={this.state.showPassword} onSubmit={this.onSubmit} onCancel={this.props.onClose} onCheckBoxChanged={this.toggleShowPassword}/>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        auth: state.auth
    }
}

export default connect(mapStateToProps)(withRouter(Edit))